const getOptionLabel = option => (option ? option.label : '')
const getOptionValue = option => (option ? option.value : '')

export { getOptionLabel, getOptionValue }
